;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    iconFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockSmallMediaWithText from './BlockSmallMediaWithText';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    ${iconFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockSmallMediaWithText(preview: $preview, id: $id) {
            __typename
            anchorId
            eyebrow
            headline {
                json
            }
            body {
                json
            }
            cta {
                ...CTA
            }
            image {
                ...Asset
            }
            backgroundColor
            youtubeVideoId
            videoPoster {
                ...Asset
            }
            videoTextureWebm {
                ...Asset
            }
            videoTextureMp4 {
                ...Asset
            }
            mediaPosition
            theme
            textAlignment
            flushTop
            flushBottom
            icon {
                ... on Icon {
                    ...Icon
                }
            }
            lockupTheme
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockSmallMediaWithText },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockSmallMediaWithText;
}

const BlockSmallMediaWithTextServer = async ({ id }) => {
    const block = await fetchBlock(id);

    return <BlockSmallMediaWithText {...block} />;
};

export default BlockSmallMediaWithTextServer;
